import { useRequest } from '@rahtab/auth/lib/token-based-auth';
import jwtdecode from 'jwt-decode';
import { useEffect, useState } from 'react';
import { BASE_URL } from '../services';

let currentToken = '';

export function clearToken() {
  currentToken = '';
}

interface getDecode {
  header: {
    typ: string;
    alg: string;
  };
  payload: {
    iss: string;
    iat: number;
    aud: any;
    nbf: number;
    exp: number;
    UserCode: string;
    EntityCode: string;
    EntityTypeCode: string;
    Permissions: boolean[];
  };
}

const url = `${BASE_URL}/dl/rahtablogin/SecurityService.aspx`;

function useToken() {
  const [token, setToken] = useState(currentToken);
  const [decode, setDecode] = useState<getDecode | undefined>(() => {
    if (!currentToken) return;
    return jwtdecode(currentToken);
  });

  const request = useRequest({ url });

  const getToken = () => {
    console.log('fetching access token ...');
    request<string>('GetJwtToken' as any)
      .then((data) => {
        setToken(data);
        currentToken = data;
        if (!currentToken) {
          getToken();
          return;
        }
        try {
          setDecode(jwtdecode(data));
        } catch (e) {
          console.error(e);
        }
      })
      .catch(getToken);
  };

  useEffect(() => {
    if (!currentToken) getToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log('token:', token);
  console.log('decoded token:', decode);

  return { token, decode, reftech: getToken };
}
export default useToken;
